import { motion } from "framer-motion";

interface ProgressBarProps {
  total: number;
  current: number; // 1-indexed current segment
}

export function ProgressBar({ total, current }: ProgressBarProps) {
  return (
    <div className="flex w-full flex-col items-center gap-1.5">
      <div className="flex w-full items-center gap-1">
        {Array.from({ length: total }).map((_, i) => {
          const idx = i + 1;
          const completed = idx < current;
          const isCurrent = idx === current;
          return (
            <div
              key={i}
              className="relative h-1.5 flex-1 overflow-hidden rounded-full bg-[#e5e7eb]"
            >
              {completed && (
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: "100%" }}
                  transition={{ duration: 0.2, ease: "easeOut" }}
                  className="h-full bg-[#10b981]"
                />
              )}
              {isCurrent && (
                <motion.div
                  className="h-full bg-[#7c8cf8]"
                  initial={{ width: "100%", opacity: 0.9 }}
                  animate={{ opacity: [0.9, 1, 0.9] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                />
              )}
            </div>
          );
        })}
      </div>
      <span className="text-[10px] uppercase tracking-[0.08em] text-[#6b7280]">
        Decision {current} of {total}
      </span>
    </div>
  );
}